import { Injectable } from "@angular/core";
import firebase from "firebase";
import { TvShow } from "../data/TvShow";
import { Season } from "../data/Season";
import { Episode } from "../data/Episode";

@Injectable()
export class TvShowsService {
  constructor() {}

  getAllTvShows() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .orderBy("addedAt", "desc")
        .get()
        .then(tvShowsSnapshot => {
          const tvShows = [];

          tvShowsSnapshot.forEach(doc => {
            const tvShow = new TvShow();

            tvShow.tvShowId = doc.id;
            tvShow.name = doc.data().name;
            tvShow.picture = doc.data().picture;
            tvShow.detailsPicture = doc.data().detailsPicture;
            tvShow.releaseYear = doc.data().releaseYear;
            tvShow.rating = doc.data().rating;
            tvShow.description = doc.data().description;
            tvShow.userRating = doc.data().userRating;
            tvShow.ratingsCount = doc.data().ratingsCount;

            tvShows.push(tvShow);
          });

          resolve({ tvShows: tvShows });
        });
    });

    return promise;
  }

  getRecentlyAddedTvSHows() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .limit(12)
        .orderBy("addedAt", "desc")
        .get()
        .then(moviesSnapshot => {
          const tvShows = [];

          moviesSnapshot.forEach(doc => {
            const ep = new Episode();

            ep.tvShowId = doc.id;
            ep.name = doc.data().name;
            ep.picture = doc.data().picture;
            ep.description = doc.data().description;
            ep.videoUrl = doc.data().videoUrl;

            tvShows.push(ep);
          });

          resolve({ tvShows: tvShows });
        });
    });

    return promise;
  }

  getTvShow(tvShowId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .doc(tvShowId)
        .get()
        .then(doc => {
          const tvShow = new TvShow();

          tvShow.tvShowId = doc.id;
          tvShow.name = doc.data().name;
          tvShow.picture = doc.data().picture;
          tvShow.detailsPicture = doc.data().detailsPicture;
          tvShow.releaseYear = doc.data().releaseYear;
          tvShow.rating = doc.data().rating;
          tvShow.description = doc.data().description;
          tvShow.userRating = doc.data().userRating;
          tvShow.ratingsCount = doc.data().ratingsCount;
          tvShow.watchers = doc.data().watchers;

          if(doc.data().premiumStatus !== undefined) {
              if(doc.data().premiumStatus == '1') {
                tvShow.premiumStatus = "1";
              } else {
                tvShow.premiumStatus = "0";
              }
          } else {
            tvShow.premiumStatus = "0"
          }

          if(tvShow.watchers == undefined) {
            tvShow.watchers = [];
          }

          resolve({ tvShow: tvShow });
        });
    });

    return promise;
  }

  addTvShowRateHistory(userId: string, tvShowId, rating) {

    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('myRatedTvSHows')
        .doc()
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          tvShowId: tvShowId,
          rating: rating
        })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  updateTvShowWatchHistory(tvShowId, watchers) {

    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('tvShows')
        .doc(tvShowId)
        .set({
          watchers: watchers
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  getSeasons(tvShow: TvShow) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .doc(tvShow.tvShowId)
        .collection("seasons")
        .orderBy("addedAt", "asc")
        .get()
        .then(tvShowSeasonsSnapshot => {
          const tvShowSeasons = [];

          tvShowSeasonsSnapshot.forEach(doc => {
            const season = new Season();

            season.seasonId = doc.id;
            season.name = doc.data().name;
            season.tvShowId = doc.data().tvShowId;
            season.tvShowName = doc.data().tvShowName;

            tvShowSeasons.push(season);
          });

          resolve({ tvShowSeasons: tvShowSeasons });
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }


  getUserWatchedTvShow(uid: string, tvShowId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("users")
        .doc(uid)
        .collection('recentlyWatchedTvShows')
        .doc(tvShowId)
        .get()
        .then(doc => {
          var show = doc.data();

          let watched = {
            watchCount: show.watchCount,
            watchProgress: show.watchProgress
          }

          if (show.watchCount !== undefined) {
            resolve({ watchedShow: watched });
          }
          else {
            resolve({ watchedShow: null });
          }
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }


  rateTvShow(tvShowId: string, rating: string) {
    let retrievedRating: Number = Number(rating);
    let averageRating: Number = 0;
    let bigRating: Number;
    let newBigRating: any;
    let newRating: any;
    let that = this;

    const promise = new Promise((resolve, reject) => {
      //Get rating
      this.getTvShow(tvShowId).then((data: any) => {
        let tvShowRating = data.tvShow.userRating;
        let tvShowRatings = data.tvShow.ratingsCount;

        console.log(tvShowRating+' - retrieved rating');
        console.log(tvShowRatings+' - retrieved ratingsCount');

        if(tvShowRating == undefined) {
          retrievedRating = 0;
          tvShowRatings = 0;


          //set rating
          this.setTvShowRating(tvShowId, Number(rating), 1);
        } else {
          retrievedRating = tvShowRating;
          tvShowRatings = tvShowRatings;
          bigRating = Number(retrievedRating) * Number(tvShowRatings);

          newBigRating = Number(bigRating) + Number(rating);
          let newRatingsCount = tvShowRatings+1
          newRating = newBigRating/newRatingsCount;



          this.setTvShowRating(tvShowId, newRating, newRatingsCount);

        }

        //Update user rate history
        let uid = localStorage.getItem('loggedInUserUID')
        that.addTvShowRateHistory(uid, tvShowId, rating);

        resolve();
      }).catch(function(error) {
        reject(error);
      });
    });

    return promise;
  }

  setTvShowRating(tvShowId: string, rating, ratingsCount) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .doc(tvShowId)
        .set(
          {
            userRating: rating,
            ratingsCount: ratingsCount
          },
          { merge: true }
        )
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  getEpisodes(tvShow: TvShow, season: Season) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("tvShows")
        .doc(tvShow.tvShowId)
        .collection("seasons")
        .doc(season.seasonId)
        .collection("episodes")
        .orderBy("addedAt", "asc")
        .get()
        .then(episodesSnapshot => {
          const seasonEpisodes = [];

          episodesSnapshot.forEach(doc => {
            const episode = new Episode();

            episode.episodeId = doc.id;
            episode.name = doc.data().name;
            episode.description = doc.data().description;
            episode.picture = doc.data().picture;
            episode.seasonId = doc.data().seasonId;
            episode.seasonName = doc.data().seasonName;
            episode.tvShowId = doc.data().tvShowId;
            episode.tvShowName = doc.data().tvShowName;
            episode.videoUrl = doc.data().videoUrl;

            if(doc.data().premiumStatus !== undefined) {
                if(doc.data().premiumStatus == '1') {
                  episode.premiumStatus = "1";
                } else {
                  episode.premiumStatus = "0";
                }
            } else {
              episode.premiumStatus = "0"
            }

            seasonEpisodes.push(episode);
          });

          resolve({ seasonEpisodes: seasonEpisodes });
        });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/services/TvShowsService.ts